import { LockClosedIcon } from "@heroicons/react/16/solid";
import { CourseDTO } from "@onetutor/shared/dto";
import { getLecturerDisplayName } from "@utils/utils";
import { readableColor } from "polished";
import { useTranslation } from "react-i18next";
import { IconWithTooltip } from "./IconWithTooltip";

interface CourseCardProps {
  course: CourseDTO & { isEnrolled?: boolean; isPasswordProtected?: boolean };
  children?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  showUniversityBadge?: boolean;
}

function CourseCard(props: CourseCardProps) {
  const { t } = useTranslation(["coursePage"]);
  const universityColor = props.course.university?.color || "#ffffff";

  const CardWrapper = props.onClick ? "button" : "div";

  return (
    <CardWrapper
      className={`card flex max-h-18 flex-row items-center justify-between rounded-xl bg-neutral px-3 py-2 text-left shadow-sm sm:px-4 sm:py-3 ${props.onClick ? "cursor-pointer hover:bg-opacity-75 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2" : ""} ${props.className || ""}`}
      onClick={props.onClick}
      type={props.onClick ? "button" : undefined}
    >
      <div className="min-w-0 flex-1">
        <h1 className="truncate font-semibold text-base sm:text-lg">
          {props.course.name}
        </h1>
        <h2 className="truncate text-base-content/80 text-sm sm:text-base">
          {getLecturerDisplayName(props.course.lecturer)}
        </h2>
      </div>
      <div className="flex flex-row items-center">
        {props.course.isPasswordProtected && !props.course.isEnrolled && (
          <IconWithTooltip
            icon={<LockClosedIcon className="h-4 w-4 sm:h-5 sm:w-5" />}
            tooltip={t("tooltipPassword")}
            tooltipPosition="left"
          />
        )}

        {props.course.university && props.showUniversityBadge && (
          <div
            className="badge badge-sm badge-primary mr-2 hidden whitespace-nowrap sm:inline-block"
            style={{
              backgroundColor: universityColor,
              color: readableColor(universityColor),
            }}
          >
            {props.course.university.shortName}
          </div>
        )}

        {props.children}
      </div>
    </CardWrapper>
  );
}

export default CourseCard;
